//#region src/houseRules/houseRuleAnswers.ts
var e = (e, t) => {
	let n = new Set(t);
	return e.map((e) => ({
		houseRuleId: e.id,
		allowed: n.has(e.id)
	}));
}, t = (e) => e.filter((e) => e.allowed).map((e) => e.id);
//#endregion
export { t as toAllowedHouseRuleIds, e as toHouseRuleAnswers };
